<template>
  <div class="w-100" @click="onClickCopyValue">
    <div v-if="title" class="input-box--title">{{ title }}</div>
    <b-input-group>
      <b-form-input
        disabled
        class="input-box--no-right-border"
        :value="showMessage"
      ></b-form-input>
      <b-input-group-append class="input--icon-right">
        <div class="d-flex justify-content-center align-items-center icon-container"> <feather-icon icon="CopyIcon" class="icon-size-20px"/></div>
      </b-input-group-append>
    </b-input-group>
    <textarea
      v-on:focus="$event.target.select()"
      readonly
      ref="copyAtomCopyInputTextBox"
      class="hidden-textbox"
      :value="copyValue"
    />
  </div>
</template>

<script>
import { BInputGroup, BFormInput, BInputGroupAppend } from "bootstrap-vue"
export default {
  name: "AtomCopyInput",
  components: {
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    showMessage: {
      type: String,
      required: false,
      default: "",
    },
    copyValue: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits:["onClickCopy"],
  methods: {
    onClickCopyValue() {
      this.$refs.copyAtomCopyInputTextBox.focus()
      document.execCommand("copy")
      this.$emit("onClickCopy")
    }
  },
}
</script>

<style lang="scss" scoped>
input[disabled] {
  cursor: pointer;
  background-color: #ffffff;
}


.input-box--title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.input-box--no-right-border{
  border-right: none;
}

.input--icon-right {
  cursor: pointer;
  .icon-container {
    background-color: #ffffff;
    border: 1px solid #d8d6de;
    border-top-right-radius:  0.357rem;
    border-bottom-right-radius:  0.357rem;
    border-left: none;
    padding-right: 1rem;
  }
}

.hidden-textbox {
  position: absolute;
  top: -99999px;
}
</style>
